import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { merge } from 'lodash'
import { withRequestSubDomain, withResponseValidationErrors } from './axios.interceptors'
import { getToken } from './token'
import { ProjectGetBaseURL } from './project'
export const getInstance = (config: AxiosRequestConfig = {}): AxiosInstance => {

  const defaultConfig: AxiosRequestConfig = {
    baseURL: process.env.VUE_APP_GPT_BASE_URL,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }

  const instance = axios.create(merge(defaultConfig, config))
  instance.interceptors.response.use((res) => res, (error)=> Promise.reject(error.response))
  instance.interceptors.request.use(withRequestSubDomain)
  return instance
}

export const getInstanceWithToken = (config: AxiosRequestConfig = {}): AxiosInstance => {
  const token = getToken()
  return getInstance(
    merge(
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
      config
    )
  )
}

export const getAffiliateInstance = (): AxiosInstance =>
  getInstanceWithToken({ baseURL: process.env.VUE_APP_GPT_BASE_URL })

export const getChatInstanceWithToken = (): AxiosInstance =>
  getInstanceWithToken({ baseURL: process.env.VUE_APP_GPT_BASE_URL})
